import axios from 'axios';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';
import { isEditableDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

// 后台字段CreateSource，9表示手动导入创建
export const CSUserImport = 9;

const CACHE_KEY_PREFIX = 'rating_first_show_';

export const RECENT_CGI = `//${window.location.hostname}/cgi-bin/online_docs/browser_list`;

export class AutoShowEntryStrategy {
    private cacheKey: string;

    public async checkIfAutoShow(): Promise<boolean> {
        window.log.info('AutoShowEntryStrategy', 'checkIfAutoShow');
        // 用户导入的，并且是创建者
        if (
            (global.basicClientVars?.docInfo?.createSource === CSUserImport || isEditableDriveFile())
            && global.basicClientVars?.docInfo?.isCreator && global.basicClientVars?.docInfo?.isOwner
        ) {
            window.log.info('AutoShowEntryStrategy', 'if');
            // 判断是否编辑过，如果编辑过要尝试清除对应的localStorage
            const isEdited = await this.checkIfEditedOrLongTime();
            window.log.info('AutoShowEntryStrategy', 'isEdited:', isEdited);
            if (isEdited) {
                // 清除localStorage里的缓存
                this.clearLocalStorage();
                return false;
            }
            // 再去拉浏览记录，看最近浏览者是不是自己
            const isRecentViewer = await this.checkIfRecentViewer();
            // 浏览记录里最近的人不是自己，尝试清除
            if (!isRecentViewer) {
                // 清除localStorage里的缓存
                this.clearLocalStorage();
                return false;
            }
            // 靠localStorage检测是否是第一次打开
            return this.checkIfFirstTime();
        }
        return false;
    }

    public recordShow() {
        // 保存到localStorage，记录下已经打开过了
        this.storeFirstTimeRecord();
    }

    private checkIfFirstTime(): boolean {
        try {
            const value = localStorage.getItem(this.getCacheKey());
            return !value;
        } catch (e) {
            return true;
        }
    }

    /**
     * 检查是否编辑过，或导入后超过的时间过长
     * @private
     */
    private async checkIfEditedOrLongTime() {
        const { docInfo } = global.basicClientVars;
        const createTime = docInfo.createInfo.createTime * 1000;
        if (docInfo.lastModifyTime !== createTime) {
            // 最近编辑时间不等于创建时间，说明编辑过
            return true;
        }
        const duringTime = performance.timing.navigationStart - createTime;
        if (duringTime / 1000 > 60 * 60 * 24 * 7) {
            // 超过7天导入还没有打开过，就不弹出了
            return true;
        }
        return false;
    }

    private clearLocalStorage() {
        // 清除localStorage里的缓存
        try {
            localStorage.removeItem(this.getCacheKey());
        } catch (e) {
            window.log.error('localStorage error ', e);
        }
    }

    private storeFirstTimeRecord() {
        try {
            localStorage.setItem(this.getCacheKey(), '1');
        } catch (e) {
            window.log.error('localStorage error ', e);
        }
    }

    /**
     * 检查是否只有自己查看过
     * @private
     */
    private async checkIfRecentViewer(): Promise<boolean> {
        try {
            const padInfo = global.basicClientVars?.docInfo?.padInfo;
            const form = new FormData();
            form.append('domain_id', padInfo?.domainId || '');
            form.append('pad_id', padInfo?.padId || '');
            form.append('start', '0');
            form.append('limit', '10');
            form.append('xsrf', getXSRF());
            form.append('t', String(new Date().getTime()));
            const { data } = await axios.post(RECENT_CGI, form);
            if (data.retcode === 0) {
                return data.total <= 1;
            }
        } catch (e) {
            window.log.error(e);
            return false;
        }
        return false;
    }

    private getCacheKey(): string {
        if (this.cacheKey) return this.cacheKey;
        const padId = global.basicClientVars?.docInfo?.padInfo.padId || {};
        this.cacheKey = `${CACHE_KEY_PREFIX}${padId}`;
        return this.cacheKey;
    }
}
